import { createAction } from 'redux-actions';
import {
  getSectionIdListRequest,
  getSectionSegmentsRequest,
  getRevisionPeriodListRequest,
  getClientEntityListRequest,
  getBlacklineViewStatusRequest,
  getSectionIdListRequestOcr,
} from 'api/statement-content-api';
import {
  getElementsBySectionRequest,
  getElementDetailsRequest,
  mapElementsWithWorkpaperInAutotieout,
} from 'api/element-api';
import { clearStatementPageRevisionStoreAction } from 'store/actions/revision-actions';
import { fetchLeftRevision } from 'store/actions/left-revision-actions';
import { isNullOrUndefined } from 'utils/object-utils';
import { updateSelectedProjectFromID } from 'store/actions/selected-project-actions';
import {
  createSectionCacheTracker,
  createLeftSectionCacheTracker,
  updateSectionViewedTimestamp,
  checkCacheToPurge,
  calculateSizeAndAddSectionToCache,
  getContentSectionMapRequest,
  getContentSectionMapOCRRequest,
} from 'store/actions/section-cache-actions';
import { ELEMENT_SELECT_MODES } from 'constants/feature/modes-constants';
import { STATEMENT_NAV_TABS } from 'constants/feature/statement-navigator-constants';
import {
  batchAddElementFormulaRows,
  initFormulaCreate,
  setNewFormulaAction,
  showFormulaPanelAction,
} from 'store/actions/formula-actions';
import {
  searchElements,
  deselectSelectedElement,
} from 'store/actions/statement-navigator/elements-search-panel-actions';
import { setSelectedTabAction } from 'store/actions/statement-navigator/navigator-panel-actions';
import { scrollSectionIntoView } from 'utils/scrolling-utils';
import { batchAddElementsToBatch } from 'store/actions/common/batch-panel-actions';
import { fetchNotesBySection } from './notes-cache-actions';
import {
  hideSectionDetailsPanelAction,
  showSectionDetailsPanelAction,
  showStatementNavPanelAction,
} from 'store/actions/panel-controller-actions';
import {
  fetchSectionReviews,
  fetchSectionOCRReviews,
  fetchSectionReviewsWithLoading,
  fetchSectionReviewsOCRWithLoading,
} from 'store/actions/sections-actions';
import {
  setStatementSocketClient,
  initStatementSocketClientAction,
} from 'store/actions/statement-socket-actions';
import { addUserToRevision } from 'store/actions/active-users-actions';
import { fetchSectionHistoryDetails } from 'store/actions/section-review-history-actions';
import { RIGHT_PANELS } from 'constants/feature/panel-constants';
import {
  fetchSectionAssignmentsList,
  fetchSectionAssignmentsOCRList,
} from 'store/actions/section-assignment-actions';
import { addElementForCopyFormula } from 'store/actions/copy-formula-actions';
import { getAllUsers } from 'store/actions/project-users-list-actions';
import { updateElementInCacheAction } from 'store/actions/element-cache-actions';
import { updateElementRequest } from 'api/element-api';
import { resetAnnotationDisplayAndPositionOption } from 'store/actions/annotation-display-actions';

import { getUpdatedSectionElementsNotesSummaryCount } from '../../utils/heading-data-utils';
import { fetchSectionTreeAction } from './section-tree-list-actions';
import {
  blacklineTogleNotification,
  isElementHasAnyAnnotations,
} from 'utils/statement-content-page-utils';
import {
  AUTO_TIEOUT_COMPARE_MODE,
  AUTO_TIEOUT_COMPARE_MODE_FAILED,
  AUTO_TIEOUT_COMPARE_MODE_INPROGRESS,
  AUTO_TIEOUT_COMPARE_MODE_SUCCESS,
  BLACKLINE_VIEW_STATUS,
  ELEMENT_QUICK_ACTIONS,
  SIDE_BY_SIDE_COMPARE_MODE,
  TRAIL_BALANCE_MODE,
} from 'constants/feature/statement-content-constants';
import {
  ELEMENT_HIGHLIGHT_STATES,
  ElementSelectionLimit,
} from 'constants/feature/tieout-element-constants';
import {
  autoTieoutProcessRequest,
  autoTieoutWorkFlowRequest,
  autoTieoutRetryRequest,
  getWorkpaperByAutoTieoutStatement,
  mapElementsRequest,
} from 'api/side-by-side-view-api';
import {
  successElementMapNotification,
  failureElementMapNotification,
  seggregateSourceTargetElements,
  getExcessiveElementSelectionNotification,
} from 'constants/feature/tieout-element-utils';
import {
  clearSideBySideElementsMap,
  replaceSelectedElementWithoutRemovingOld,
  clearSelectedElementsContentPanel,
  replaceSelectedElementsContentPanel,
  clearBatchSelectedElementsAction,
  clearingElementMapSuccessAction,
} from 'store/actions/action-creators';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';
import { updateCacheWithMostRecentSideBySideElementChanges } from 'store/actions/element-changes-since-tracker-actions';
import { CONTEXT_KEY } from 'api/api-constants';
import {
  fetchSelectedStatement,
  selectedStatementError,
} from './selected-statement-actions';
import {
  addElementsToSourceListInSideBySideMode,
  addElementsToTargetListInSideBySideMode,
} from './left-side-by-side-batch-actions';
import { getSelectedStatementOCRNavigationData } from './ocr-navigation-actions';
import {
  fetchAllOCRSectionRenderingData,
  fetchElementsBySectionOCR,
  fetchSectionOCRSegmentsStatementContent,
} from './statement-content-actions-ocr';
import { isElementReportPreviewPage } from 'utils/ocr-annotation-utils';
import { updateElementCacheByCalloutAction } from './element-cache-actions';
import { updateSideBySideElementCacheByCallouts } from 'store/actions/statement-content-annotation-creation-actions';
import {
  setSourceStatementBatchElementsMapAction,
  setTargetStatementBatchElementsMapAction,
  selectMultipleElementsContentPanel,
} from 'store/actions/action-creators';
import Permissions from 'permissions/permissions';
import { scrollOCRBookmarkIntoView } from 'utils/scrolling-utils';
import { getChatBotFeatureFlagsByClientId } from 'api/chatbot-api';
import { clearLeftStatementPageStoreAction } from 'store/actions/left-statement-content-actions';
import ElementDetails from 'models/api/element-details-api-model';
import { StatusCodes } from 'http-status-codes';
import {
  autoTieoutWorkflowDataError,
  autoTieoutWorkflowDataLoaded,
  autoTieoutWorkflowDataLoading,
  removeAutoTieoutWorkpaperReference,
  resetAutoTieoutWorkflowData,
  setAutoTieoutStatusForBanner,
  setAutoTieoutWorkpaperReference,
} from './auto-tieout/workpaper-details-action';
import { getAutoTieoutMapedElements } from 'api/auto-tieout-api';
import {
  fetchAutoTieoutMapedElements,
  clearAutoTieoutMapedElements,
  autoTieoutMapedElementsLoaded,
  autoTieoutMapedElementsError,
  removeSourceElementClicked,
  removeTargetElementClicked,
} from 'store/actions/auto-tieout/mapped-elements-actions';
import {
  _updateElementInStoreAndElementCacheByQuickAction,
  excludeElement,
  unlinkElementWorkpaperFromAutoTieout,
} from 'store/actions/element-panel-actions';
import { onElementClick } from 'components/feature/statement-content-panel/tieout-element-component';
import {
  // deleteFormulaRequestByQuickAction,
  getFormulasForElementRequest,
} from 'api/formula-api';
import { FORMULA_ROW_TYPES } from 'constants/feature/formula-constants';
import FormulaRowNumber from 'models/data/formula/formula-row-number-model';
import FormulaRowOperator from 'models/data/formula/formula-row-operator-model';
import FormulaRowElement from 'models/data/formula/formula-row-element-model';
import { resetSideBySideViewMode } from './side-by-side-view-annotations-actions';
import { initiateAutoTieoutForTrialBalance } from './trial-balance/trial-balance-action';
import {
  setThreshold,
  resetThresholdScaling,
  resetTrailBalanceWorkFlowStatus,
} from 'store/actions/trial-balance/trial-balance-action';
import {
  clearTrialBalanceMapedElements,
  fetchTrialBalanceMapedElements,
  removeTBSourceElementClicked,
  removeTBTargetElementClicked,
  resetMappedElements,
} from 'store/actions/trial-balance/mapped-element-action';
import { setAnnotationDisplayOption } from 'store/actions/annotation-display-actions';
import { cancelBatchUpdatePanel } from 'store/actions/batch-panel-actions';
import { clearModeIfPossible } from 'store/actions/modes-actions';
import { fetchStatementCreationPageData } from './statement-creation-page-data-actions';

let isIntervalAlreadySet = null;
export const mapElementsSuccessResult = 'success';
export const mapElementsFailureResult = 'failure';

const clearLeftSelectedStatement = createAction(
  'CLEAR_LEFT_SELECTED_STATEMENT',
);
const clearleftSectionTreeListAction = createAction(
  'LEFT_STATEMENT_CLEAR_SECTION_TREE_LIST_ACTION',
);
export const selectNoteFromNoteListAction = createAction(
  'SELECTED_NOTE_FROM_NOTE_LIST',
); //duplicate: To avoid circular dependency
export const sectionIdListStatementContentLoading = createAction(
  'SECTION_ID_LIST_STATEMENT_CONTENT_LOADING',
);
export const sectionIdListStatementContentLoaded = createAction(
  'SECTION_ID_LIST_STATEMENT_CONTENT_LOADED',
);
export const sectionIdListStatementContentError = createAction(
  'SECTION_ID_LIST_STATEMENT_CONTENT_ERROR',
);
export const sectionIdListStatementContentOcrLoading = createAction(
  'SECTION_ID_LIST_STATEMENT_CONTENT_OCR_LOADING',
);
export const sectionIdListStatementContentOcrLoaded = createAction(
  'SECTION_ID_LIST_STATEMENT_CONTENT_OCR_LOADED',
);
export const sectionIdListStatementContentOcrError = createAction(
  'SECTION_ID_LIST_STATEMENT_CONTENT_OCR_ERROR',
);
export const leftSectionIdListStatementContentLoading = createAction(
  'LEFT_SECTION_ID_LIST_STATEMENT_CONTENT_LOADING',
);
export const leftSectionIdListStatementContentLoaded = createAction(
  'LEFT_SECTION_ID_LIST_STATEMENT_CONTENT_LOADED',
);
export const leftSectionIdListStatementContentError = createAction(
  'LEFT_SECTION_ID_LIST_STATEMENT_CONTENT_ERROR',
);
export const sectionHTMLSegmentsStatementContentLoading = createAction(
  'SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_LOADING',
);
export const sectionHTMLSegmentsStatementContentLoaded = createAction(
  'SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_LOADED',
);
export const sectionHTMLSegmentsStatementContentLoadedWithoutResponse =
  createAction(
    'SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_LOADED_WITHOUT_RESPONSE',
  );
export const sectionHTMLSegmentsStatementContentError = createAction(
  'SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_ERROR',
);

export const leftSectionHTMLSegmentsStatementContentLoadedWithoutResponse =
  createAction(
    'LEFT_SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_LOADED_WITHOUT_RESPONSE',
  );
export const setSectionInViewStatementContent = createAction(
  'SET_SECTION_IN_VIEW_STATEMENT_CONTENT',
);
export const clearSectionInViewStatementContent = createAction(
  'CLEAR_SECTION_IN_VIEW_STATEMENT_CONTENT',
);

export const sectionElementsLoading = createAction('SECTION_ELEMENTS_LOADING');
export const sectionElementsLoaded = createAction('SECTION_ELEMENTS_LOADED');
export const sectionElementsError = createAction('SECTION_ELEMENTS_ERROR');

export const clearLeftStatementContent = createAction(
  'CLEAR_LEFT_STATEMENT_CONTENT',
);
export const setStatementContentTab = createAction('SET_STATEMENT_CONTENT_TAB');

export const deselectElementsFromArrayContentPanel = createAction(
  'DESELECT_ELEMENT_FROM_ARRAY_CONTENT_PANEL',
);
export const clearLeftSelectedElementsContentPanel = createAction(
  'CLEAR_LEFT_SELECTED_ELEMENTS_CONTENT_PANEL',
);
export const replaceLeftSelectedElementWithoutRemovingOld = createAction(
  'REPLACE_LEFT_SELECTED_ELEMENTS_WITHOUT_REMOVING_OLD',
);
export const deallocateSelectedElementsContentPanel = createAction(
  'DEALLOCATE_SELECTED_ELEMENTS_CONTENT_PANEL',
);

export const setHighlightedElementIdContentPanel = createAction(
  'SET_HIGHLIGHTED_ELEMENT_ID_CONTENT_PANEL',
);

export const selectSectionContentPanel = createAction(
  'SELECT_SECTION_CONTENT_PANEL',
);
export const deselectSectionContentPanel = createAction(
  'DESELECT_SECTION_CONTENT_PANEL',
);
export const clearSelectedSectionsContentPanel = createAction(
  'CLEAR_SELECTED_SECTIONS_CONTENT_PANEL',
);
export const selectMultipleSectionsContentPanel = createAction(
  'SELECT_MULTIPLE_SECTIONS_CONTENT_PANEL',
);
export const replaceSelectedSectionsContentPanel = createAction(
  'REPLACE_SELECTED_SECTIONS_CONTENT_PANEL',
);
export const deallocateSelectedSectionsContentPanel = createAction(
  'DEALLOCATE_SELECTED_SECTIONS_CONTENT_PANEL',
);
export const periodListStatementContentLoading = createAction(
  'PERIOD_LIST_STATEMENT_CONTENT_LOADING',
);
export const periodListStatementContentLoaded = createAction(
  'PERIOD_LIST_STATEMENT_CONTENT_LOADED',
);
export const periodListStatementContentError = createAction(
  'PERIOD_LIST_STATEMENT_CONTENT_ERROR',
);

export const entityListStatementContentLoading = createAction(
  'ENTITY_LIST_STATEMENT_CONTENT_LOADING',
);

export const entityListStatementContentLoaded = createAction(
  'ENTITY_LIST_STATEMENT_CONTENT_LOADED',
);

export const entityListStatementContentError = createAction(
  'ENTITY_LIST_STATEMENT_CONTENT_ERROR',
);

export const setContentSearchAction = createAction('SET_CONTENT_SEARCH');
export const clearContentSearchAction = createAction('CLEAR_CONTENT_SEARCH');

export const setContentHighlightSelector = createAction(
  'SET_CONTENT_HIGHLIGHT_SELECTOR',
);

export const clearContentHighlightSelector = createAction(
  'CLEAR_CONTENT_HIGHLIGHT_SELECTOR',
);
export const clearStatementPageStoreAction = createAction(
  'CLEAR_STATEMENT_PAGE_STORE',
);

export const elementDatapartStoreAction = createAction(
  'UPDATE_ELEMENT_DATAPART_STORE',
);

export const sectionDetailsLoaded = createAction('SECTION_DETAILS_LOADED');
export const sectionDetailsLoading = createAction('SECTION_DETAILS_LOADING');
export const clearSectionDetails = createAction('CLEAR_SECTION_DETAILS');

export const setSourceSyncScrollId = createAction('SET_SOURCE_STATEMENT_ID');
export const setTargetSyncScrollId = createAction('SET_TARGET_STATEMENT_ID');

export const chatBotFeatureFlagsLoading = createAction(
  'CHAT_BOT_FEATURE_FLAGS_LOADING',
);
export const chatBotFeatureFlagsLoaded = createAction(
  'CHAT_BOT_FEATURE_FLAGS_LOADED',
);
export const chatBotFeatureFlagsError = createAction(
  'CHAT_BOT_FEATURE_FLAGS_ERROR',
);

//common function used to seggregate source and current(target) elements based on the response from element map request in side by side view page.
export const highlightMappedElementsByResponse =
  ({ result, sourceElements, targetElements }) =>
  async (dispatch) => {
    dispatch(
      replaceLeftSelectedElementWithoutRemovingOld({
        elementIds: sourceElements,
        color:
          result === mapElementsSuccessResult
            ? ELEMENT_HIGHLIGHT_STATES.ELEMENT_MAP_SUCCESS
            : ELEMENT_HIGHLIGHT_STATES.ELEMENT_MAP_FAILURE,
      }),
    );
    dispatch(
      replaceSelectedElementWithoutRemovingOld({
        elementIds: targetElements,
        color:
          result === mapElementsSuccessResult
            ? ELEMENT_HIGHLIGHT_STATES.ELEMENT_MAP_SUCCESS
            : ELEMENT_HIGHLIGHT_STATES.ELEMENT_MAP_FAILURE,
      }),
    );
  };

export const handleElementMappingFailure =
  (mapElementsFailureResult, sourceElements, targetElements) =>
  async (dispatch) => {
    //if element mapping request failed it triggers below code
    dispatch(
      highlightMappedElementsByResponse({
        result: mapElementsFailureResult,
        sourceElements,
        targetElements,
      }),
    );
    dispatch(clearSideBySideElementsMap());
    // failed mapped elements notification
    failureElementMapNotification({
      processType: SIDE_BY_SIDE_COMPARE_MODE,
      targetElements,
    });
  };

export const fetchSectionIdListStatementContent =
  (revisionId, isOCR, projectId, statementId) => async (dispatch, getStore) => {
    dispatch(sectionIdListStatementContentLoading());
    try {
      const response = await getSectionIdListRequest({
        revisionId,
        isOCR,
        clientId: projectId,
        statementId,
      });
      const { selectedStatement } = getStore().data;
      if (window.location.pathname.includes('statement')) {
        dispatch(
          sectionIdListStatementContentLoaded({
            response,
            isOCR: selectedStatement.isOCR, //used in section cache model to store image
          }),
        );
      }
    } catch (error) {
      dispatch(sectionIdListStatementContentError(error));
    }
  };

export const fetchSectionIdListStatementContentOcr =
  (revisionId, projectId, statementId) => async (dispatch) => {
    dispatch(sectionIdListStatementContentOcrLoading());
    try {
      const response = await getSectionIdListRequestOcr({
        revisionId,
        clientId: projectId,
        statementId,
      });
      dispatch(
        sectionIdListStatementContentOcrLoaded({
          response,
        }),
      );
    } catch (error) {
      dispatch(sectionIdListStatementContentOcrError(error));
    }
  };

export const fetchLeftSectionIdListStatementContent =
  (revisionId, statementId, projectId, isOCR) => async (dispatch) => {
    dispatch(leftSectionIdListStatementContentLoading());
    try {
      const response = await getSectionIdListRequest(
        { revisionId, statementId, isOCR, clientId: parseInt(projectId) },
        {
          contextKey: CONTEXT_KEY.PROJECT_CONTEXT,
          contextValue: projectId,
        },
      );
      dispatch(
        leftSectionIdListStatementContentLoaded({
          response,
          isOCR,
        }),
      );
    } catch (error) {
      dispatch(leftSectionIdListStatementContentError(error));
    }
  };

export const fetchRevisionPeriodList =
  (revisionId, statementId) => async (dispatch) => {
    dispatch(periodListStatementContentLoading());
    try {
      const response = await getRevisionPeriodListRequest(
        revisionId,
        statementId,
      );
      dispatch(
        periodListStatementContentLoaded({
          response,
        }),
      );
    } catch (error) {
      dispatch(periodListStatementContentError(error));
    }
  };

export const fetchClientEntityList = (clientId) => async (dispatch) => {
  dispatch(entityListStatementContentLoading());
  try {
    const response = await getClientEntityListRequest(clientId);
    dispatch(
      entityListStatementContentLoaded({
        response,
      }),
    );
  } catch (error) {
    dispatch(entityListStatementContentError(error));
  }
};

export const fetchSectionHTMLSegmentsStatementContentWithoutLoading =
  ({ sectionIdList, segmentType }) =>
  async (dispatch, getStore) => {
    const {
      data: { revision },
    } = getStore();
    getSectionSegmentsRequest({
      revisionId: revision.id,
      sectionIdList,
      segmentType,
    })
      .then((response) => {
        const {
          ui: {
            statementPage: { contentSearch },
          },
        } = getStore();
        dispatch(
          sectionHTMLSegmentsStatementContentLoaded({
            response,
            searchTerm: contentSearch,
          }),
        );
        dispatch(
          calculateSizeAndAddSectionToCache({ sectionId: sectionIdList[0] }),
        );
        // after set in cache, evaluate cache
        dispatch(checkCacheToPurge());
        dispatch(
          elementDatapartStoreAction({
            response,
          }),
        );
      })
      .catch((error) => {
        dispatch(sectionHTMLSegmentsStatementContentError(error));
      });
  };

export const fetchSectionHTMLSegmentsStatementContent =
  ({ sectionIdList, segmentType, scrollToSection }) =>
  async (dispatch, getStore) => {
    const {
      data: { revision },
    } = getStore();
    const locationPath = window.location.pathname.split('/');
    const revisionId = locationPath[locationPath.indexOf('revision') + 1];
    dispatch(sectionHTMLSegmentsStatementContentLoading(sectionIdList));
    getSectionSegmentsRequest({
      revisionId: revision.id || revisionId,
      sectionIdList,
      segmentType,
    })
      .then((response) => {
        const {
          ui: {
            statementPage: { contentSearch },
          },
        } = getStore();
        dispatch(
          sectionHTMLSegmentsStatementContentLoaded({
            response,
            searchTerm: contentSearch,
          }),
        );
        const sectionId = sectionIdList[0];
        if (scrollToSection && !isNullOrUndefined(sectionId)) {
          scrollSectionIntoView(sectionId);
        }
        dispatch(
          calculateSizeAndAddSectionToCache({ sectionId: sectionIdList[0] }),
        );
        // after set in cache, evaluate cache
        dispatch(checkCacheToPurge());
        dispatch(
          elementDatapartStoreAction({
            response,
          }),
        );
      })
      .catch((error) => {
        dispatch(sectionHTMLSegmentsStatementContentError(error));
      });
  };

export const fetchElementsBySection =
  ({ sectionId, withoutLoading = false, isAutoTieoutProcess = false }) =>
  async (dispatch, getStore) => {
    const {
      revision,
      annotationDisplayOptions,
      statementContent: { elementCache },
    } = getStore().data;

    const locationPath = window.location.pathname.split('/');
    const revisionId = locationPath[locationPath.indexOf('revision') + 1];
    const isPreviewPage = isElementReportPreviewPage(window.location.pathname);

    !withoutLoading && dispatch(sectionElementsLoading({ sectionId }));
    return getElementsBySectionRequest({
      sectionId,
      revisionId: revision.id || revisionId,
      isPreviewPage,
    })
      .then((response) => {
        if (
          response.data &&
          (annotationDisplayOptions.showAll || isAutoTieoutProcess)
        ) {
          response.data = response.data.map((item) => {
            return {
              ...item,
              marker: false,
              callout: isElementHasAnyAnnotations(item),
            };
          });
        } else if (elementCache.getCurrentSectionIds().length) {
          const elementIds = elementCache.getElementIdsBySectionId({
            sectionId,
          });
          if (elementIds.marker.length || elementIds.callout.length) {
            response.data = response.data.map((item) => {
              return {
                ...item,
                marker: elementIds.marker.includes(item.id),
                callout:
                  elementIds.callout.includes(item.id) &&
                  isElementHasAnyAnnotations(item),
              };
            });
          }
        }
        dispatch(
          sectionElementsLoaded({
            response,
            sectionId,
          }),
        );
        return response;
      })
      .catch((error) => {
        dispatch(sectionElementsError({ sectionId, error }));
      });
  };

/**
 * Fetches all data necessary for rendering section content and element annotations
 * @param {number} param.sectionId sectionId to fetch info for
 */
export const fetchAllSectionRenderingData =
  ({ sectionId, scrollToSection, isReportPreviewPage = false }) =>
  (dispatch, getState) => {
    const { blacklineViewMode } = getState().ui.statementPage.modes;

    dispatch(
      fetchSectionHTMLSegmentsStatementContent({
        sectionIdList: [sectionId],
        segmentType: blacklineViewMode ? 'C' : 'P',
        scrollToSection,
      }),
    );
    dispatch(fetchElementsBySection({ sectionId }));
    !isReportPreviewPage && dispatch(fetchNotesBySection({ sectionId }));
  };

export const fetchAllSectionRenderingDataWithoutLoading =
  ({ sectionId }) =>
  (dispatch, getState) => {
    const { blacklineViewMode } = getState().ui.statementPage.modes;

    dispatch(
      fetchSectionHTMLSegmentsStatementContentWithoutLoading({
        sectionIdList: [sectionId],
        segmentType: blacklineViewMode ? 'C' : 'P',
      }),
    );
    dispatch(fetchElementsBySection({ sectionId }));
    dispatch(fetchNotesBySection({ sectionId }));
  };

export const setCurrentStatementContentTab = (tab) => async (dispatch) => {
  //First set the new tab that is passed in.
  await dispatch(setStatementContentTab(tab));
  /**
   * TODO: If we want to support multiple routes for the different tabs, we will have to investigate the logic for it
   * here with some type of react router/redux combination approach. TBD.
   */
  // /**
  //  * Next we set the url parameters for the new page based on the tab and
  //  * parameters in the store, namely the currently rendered revision and the currently
  //  * selected project.
  //  */
  // const currentState = getState().data;
  // const selectedProject = currentState.selectedProject.project;
  // const revision = currentState.revision;
  // if (!selectedProject.isInitialized() || !revision.isInitialized()) {
  //   const errorMessage =
  //     'Cannot select a tab, user does not have a selected project, or a revision loaded.';
  //   console.error(errorMessage);
  //   throw new Error(errorMessage);
  // }
  // let route;
  // if (tab === STATEMENT_CONTENT_TABS.STATEMENT) {
  //   route = ROUTE_CONSTANTS.STATEMENT_CONTENT_PAGE;
  // } else if (tab === STATEMENT_CONTENT_TABS.SPLIT) {
  //   route = ROUTE_CONSTANTS.STATEMENT_SPLIT_PAGE;
  // }
  // // TODO: Once we have better readOnly support, refactor its logic to be store-based somehow.
  // await dispatch(
  //   push(
  //     parseRoute(route, {
  //       params: {
  //         projectId: selectedProject.id,
  //         statementId: revision.statementId,
  //         revisionId: revision.id,
  //         readOnly: false,
  //       },
  //     }),
  //   ),
  // );
};

/**
 * @param {} urlParams
 */
export const initStatementContent =
  (urlParams) => async (dispatch, getState) => {
    const projectId = urlParams.projectId;
    const pathname = window.location.pathname;
    const statementId = parseInt(urlParams.statementId);
    const revisionId = parseInt(urlParams.revisionId);
    dispatch(
      createSectionCacheTracker({
        revisionId,
      }),
    );
    // Once it has been fetched, we need to use our urlParams to ensure the proper project is the selected one in the store.
    const { data: currentState } = getState();

    const currentUserId =
      currentState && currentState.currentUser && currentState.currentUser.id;
    const selectedProject = currentState.selectedProject.project;

    // const { socketHasBeenDisconnected } = sockets.statementSocket;

    /**
     * If the selected project in the store is not the same as the one in the url params, update it.
     * This can happen if the user refreshes the page, or if they navigate to this page directly from a
     * bookmarked url for instance.
     *  */

    if (selectedProject.id !== projectId) {
      // Verify if projectid in url is present in projectToGeoMap
      const { projectToGeoMap } =
        currentState.currentUser && currentState.currentUser.data;
      const desiredProject = projectToGeoMap.get(`${projectId}`);
      /**
       * If the user puts in a project id in the url that is not valid, meaning it is not found in the projectToGeoMap,
       * we display an error.
       * TODO: Refactor this when we fix up overall error handling in the application.
       */
      if (isNullOrUndefined(desiredProject)) {
        const errorMessage = `Project with id: ${projectId} does not exist`;
        dispatch(selectedStatementError(errorMessage));
        console.error(errorMessage);
        throw new Error(errorMessage);
      }
      // We always fire off an update to the selected project to ensure the proper project is marked as selected in the store.
      await dispatch(
        updateSelectedProjectFromID({
          projectId,
        }),
      );
    }

    await dispatch(fetchSelectedStatement(urlParams));
    await dispatch(fetchChatbotFeatureFlags(projectId)); // to get all chatbot feature flags for the project
    // We need to update the revision in the store to ensure we have the proper information to display in the UI.
    // all content requests for the statement require that the revision number be known
    //await dispatch(fetchRevision(revisionId));
    const {
      data: { selectedStatement },
    } = getState();

    // If we are not in side by side view mode, reset the side by side view mode in the store
    !window.location.pathname.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE) &&
      dispatch(resetSideBySideViewMode());

    // Next, get the section id map and the associated content so we can display the statement properly.
    // MUST await as this determines the order sections are rendered in
    await dispatch(
      fetchSectionIdListStatementContent(
        revisionId,
        selectedStatement.isOCR,
        parseInt(projectId),
        statementId,
      ),
    );

    // Finally fetch the period list for the current statement to populate the element details dropdown.
    if (statementId && revisionId) {
      dispatch(fetchRevisionPeriodList(revisionId, statementId));
    }
    dispatch(fetchClientEntityList(projectId));
    if (selectedStatement.isOCR) {
      await dispatch(
        getSelectedStatementOCRNavigationData(projectId, revisionId),
      );
      dispatch(
        getContentSectionMapOCRRequest({
          revisionId,
          isOCR: selectedStatement.isOCR,
          statementId,
        }),
      );
      await dispatch(
        fetchSectionIdListStatementContentOcr(
          revisionId,
          parseInt(projectId),
          statementId,
        ),
      );
      dispatch(setSelectedTabAction(STATEMENT_NAV_TABS.pages));
      dispatch(
        fetchSectionTreeAction({
          revisionId,
          isOCR: selectedStatement.isOCR,
          statementId,
        }),
      );
      dispatch(fetchSectionOCRReviews(revisionId, statementId));
    }
    if (!selectedStatement.isOCR && statementId && revisionId) {
      // fetch contentSectionMap for relationships between content and bookmark sections
      dispatch(getContentSectionMapRequest({ revisionId, statementId }));
      //TODO: Uncomment out this dispatch for socket subscription once that is setup on the back-end.
      // subscribe({ projectId, statementId, revisionId });

      // It will fetch section tree list used for rendering statement-nav panel
      dispatch(fetchSectionTreeAction({ revisionId, statementId }));
      // it will set default heading tab in statement navigational panel
      dispatch(setSelectedTabAction(STATEMENT_NAV_TABS.headings));
      dispatch(fetchSectionReviews(revisionId, statementId));
    }
    // init statement nav panel as open by default when loading statement page
    dispatch(showStatementNavPanelAction());

    await dispatch(
      initStatementSocketClientAction({
        revisionId,
        projectId,
        currentUserId,
      }),
    );

    dispatch(setStatementSocketClient({ dispatch, getState }));
    if (!isElementReportPreviewPage(pathname)) {
      if (statementId && revisionId) {
        if (!selectedStatement.isOCR) {
          dispatch(fetchSectionAssignmentsList({ revisionId, statementId }));
        } else {
          dispatch(fetchSectionAssignmentsOCRList({ revisionId, statementId }));
        }
      }
      await dispatch(getAllUsers());

      //Before loading statement content for the first time, load the details of active users from BE.
      await dispatch(addUserToRevision(revisionId, projectId));
      // Don't set interval if there is already one in place;
      if (!isIntervalAlreadySet) {
        // We need to refresh the users in the room every 1hour
        isIntervalAlreadySet = setInterval(
          () => dispatch(addUserToRevision(revisionId, projectId)),
          3600000,
        );
      }
      // TODO : Code to be uncommented when we are developing feature related to instant update of active users on statement.
      // if (socketHasBeenDisconnected) {
      //   dispatch(addUserToRevision(revisionId, projectId));
      // }
    }

    await dispatch(fetchStatementCreationPageData());
  };

export const initLeftStatementContent =
  (sourceStatementParams) => async (dispatch, getState) => {
    // const statementId = parseInt(sourceStatementUrlParams.statementId);
    const revisionId = parseInt(sourceStatementParams.revisionId);
    const statementId = parseInt(sourceStatementParams.statementId);
    const { projectId } = sourceStatementParams;
    //creating the section cache tracker for left statement in side by side view page
    dispatch(
      createLeftSectionCacheTracker({
        revisionId,
      }),
    );
    // We need to update the revision in the store to ensure we have the proper information to display in the UI.
    // all content requests for the statement require that the revision number be known
    await dispatch(fetchLeftRevision(revisionId, statementId, projectId));
    // Next, get the section id map and the associated content so we can display the statement properly.
    // MUST await as this determines the order sections are rendered in
    const {
      data: { selectedStatement },
    } = getState();
    const _isSideBySideView = window.location.pathname.includes(
      ROUTE_CONSTANTS.SIDE_BY_SIDE,
    );

    !_isSideBySideView &&
      (await dispatch(
        fetchLeftSectionIdListStatementContent(
          revisionId,
          statementId,
          projectId,
          selectedStatement.isOCR,
        ),
      ));
  };

// fetching chatbot feature flags by client id based on the feature flags in the store w.r.t geo code
// with retry mechanism to check if feature flags are loaded in the store
// before fetching chatbot feature flags
export const fetchChatbotFeatureFlags =
  (clientId) => async (dispatch, getState) => {
    try {
      const MAX_RETRIES = 2;
      const DELAYS = [0, 100, 400];

      let featureFlags;

      for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
        const currentFeatureFlags = getState().data?.featureFlags;

        if (currentFeatureFlags?.isLoaded) {
          featureFlags = currentFeatureFlags;
          break;
        }

        if (attempt < MAX_RETRIES) {
          await new Promise((resolve) =>
            setTimeout(resolve, DELAYS[attempt + 1]),
          );
        }
      }

      if (!featureFlags?.isLoaded) {
        throw new Error(
          `Feature flags not available after ${MAX_RETRIES} retries. Please try again later.`,
        );
      }

      const clientGeoCode = clientId.split('-')[1];

      const chatBotFeatureFlags =
        featureFlags.getChatbotFeatures?.(clientGeoCode);
      if (!chatBotFeatureFlags) {
        console.warn(`No chatbot features found for geoCode: ${clientGeoCode}`);
      }

      dispatch(chatBotFeatureFlagsLoading());

      const response = await getChatBotFeatureFlagsByClientId({
        chatBotFeatureFlags,
        clientId,
      });

      dispatch(chatBotFeatureFlagsLoaded({ response }));
    } catch (error) {
      console.error('fetchChatbotFeatureFlags error:', {
        clientId,
        error: error.message,
        stack: error.stack,
      });
      dispatch(chatBotFeatureFlagsError(error));
    }
  };
/**
 * Adds section to SectionInViewMap and updates it's viewed timestamp in the SectionCacheTracker
 * @param {int} param.sectionId
 */
export const setSectionInView =
  ({ sectionId }) =>
  (dispatch) => {
    dispatch(setSectionInViewStatementContent({ sectionId }));
    dispatch(updateSectionViewedTimestamp({ sectionId }));
  };

/**
 * Removes a section from the SectionInViewMap
 *
 * Sometimes the cache will still be too large if the transition between 2 large sections is within the viewport threshold
 * thus every time we clear a seciton in view, we should also check the cache and see if we can purge a section that is no longer
 * in view so we can get below the threshold
 * @param {int} param.sectionId
 */
export const clearSectionInView =
  ({ sectionId }) =>
  async (dispatch, getStore) => {
    dispatch(clearSectionInViewStatementContent({ sectionId }));
    const { tracker } = getStore().data.statementContent.sectionsCache;
    const _cacheOverThreshold = tracker.cacheOverThreshold();
    if (_cacheOverThreshold) {
      dispatch(checkCacheToPurge());
    }
  };

export const clearStatementPageStore = () => (dispatch) => {
  dispatch(clearStatementPageStoreAction());

  // We dont want to clear revision id when navigating to side by side page,
  // since, we will need it for fetching data for target statement
  !(
    window.location &&
    window.location.pathname &&
    window.location.pathname.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE)
  ) && dispatch(clearStatementPageRevisionStoreAction());

  // Reset annotation display options when leaving statement page
  dispatch(resetAnnotationDisplayAndPositionOption());

  //TODO: Restore this code once we have back-end support for sockets.
  //unsubscribe();
};

export const expandAllElements =
  ({ elementIds, showCallout = true }) =>
  (dispatch, getState) => {
    const store = getState();
    const { data } = store;
    const {
      annotationDisplayOptions: { expandAllElements },
    } = data;

    expandAllElements &&
      dispatch(
        updateSideBySideElementCacheByCallouts({
          elementIds,
          showCallout,
        }),
      );
  };

export const batchSelectElements =
  ({ elements }) =>
  (dispatch, getState) => {
    const { selectMode } = getState().ui.statementPage.modes;
    // then dispatch the mode specific action
    switch (selectMode) {
      case ELEMENT_SELECT_MODES.FORMULA: {
        // always select all the elements in the content panel
        dispatch(
          selectMultipleElementsContentPanel({
            elementIds: elements.map((el) => el.elementId),
          }),
        );
        dispatch(
          batchAddElementFormulaRows({
            elements,
          }),
        );
        break;
      }
      case ELEMENT_SELECT_MODES.BATCH_WITH_BANNER:
      case ELEMENT_SELECT_MODES.BATCH: {
        dispatch(
          expandAllElements({
            elementIds: elements.map((el) => el.elementId),
          }),
        );
        dispatch(batchAddElementsToBatch({ elements }));
        break;
      }
      case ELEMENT_SELECT_MODES.COPY_FORMULA: {
        elements.forEach((ele) =>
          dispatch(addElementForCopyFormula({ elementId: ele.elementId })),
        );
        break;
      }
      default:
        break;
    }
  };

export const batchSelectElementsInSideBySideMode =
  ({ elements, isLeftSideView }) =>
  async (dispatch, getState) => {
    const {
      data,
      ui: {
        sourceStatementParams,
        sideBySideView: { sideBySideElementMap },
      },
    } = getState();

    const { projectId } = sourceStatementParams;

    const hasPermission =
      Permissions.SideBySideStatementViewPermissions.canSelectElement(
        data,
        projectId,
      );
    // Filter out elements with valid elementId
    const selectedElements = elements.filter((ele) => !isNaN(ele.elementId));
    // only if user with certain roles has permission can select elements in left side on side by side view and if user is not selected in source side then he won't be able to select elements in target side
    if (hasPermission) {
      if (isLeftSideView) {
        if (
          sideBySideElementMap?.sizeOfSourceMapping + selectedElements?.length >
          ElementSelectionLimit
        ) {
          getExcessiveElementSelectionNotification(ElementSelectionLimit);
          return;
        } else {
          // Dispatch action to add elements to source list in side by side view mode
          const selectedElementsfromCache = await dispatch(
            addElementsToSourceListInSideBySideMode({
              elements: selectedElements,
            }),
          );
          // Get the array of elements data from the elements map object
          const sourceSideBySideElements =
            getElementsDataArryaFromElementsMapObject(
              selectedElementsfromCache,
            );

          // Dispatch action to set the source statement batch elements map
          dispatch(
            setSourceStatementBatchElementsMapAction(sourceSideBySideElements),
          );
        }
      } else {
        // Dispatch action to add elements to target list in side by side view mode
        const selectedTargetElementsfromcache = await dispatch(
          addElementsToTargetListInSideBySideMode({
            elements: selectedElements,
          }),
        );

        const targetSideBySideElements =
          getElementsDataArryaFromElementsMapObject(
            selectedTargetElementsfromcache,
          );

        dispatch(
          setTargetStatementBatchElementsMapAction(targetSideBySideElements),
        );
      }
    }
  };

const getElementsDataArryaFromElementsMapObject = (selectedElementsMap) =>
  Object.values(selectedElementsMap).map((item) => item.data);

export const onStatementNavSectionSelect =
  ({ sectionId, color, bookmarkId, isOCR, sectionsInView }) =>
  async (dispatch) => {
    dispatch(
      replaceSelectedSectionsContentPanel({
        sectionIds: [sectionId],
        color,
        bookmarkId,
      }),
    );
    !isOCR
      ? scrollSectionIntoView(sectionId)
      : scrollOCRBookmarkIntoView({
          bookmarkId,
          sectionId,
          sectionsInView,
          isOCR,
        });
  };

export const onSectionClick =
  ({ sectionId, color, sectionClick, bookmarkId }) =>
  async (dispatch, getState) => {
    const { elementFilters } =
      getState().ui.statementPage.statementNavigatorPanel;
    const { sectionsInView } = getState().ui.statementPage;
    const { contentSectionMap } =
      getState().data.statementContent.sectionsCache;

    const { isOCR } = getState().data.selectedStatement;

    const { selectMode } = getState().ui.statementPage.modes;
    const { right } = getState().ui.statementPage.panels;

    const {
      data: { revision },
    } = getState();

    const { INTERNAL_REFERENCE, FORMULA, BATCH, COPY_FORMULA } =
      ELEMENT_SELECT_MODES;
    const shouldDisableSectionClick =
      selectMode === INTERNAL_REFERENCE ||
      selectMode === FORMULA ||
      selectMode === COPY_FORMULA ||
      right === BATCH.title;
    let section = isOCR
      ? contentSectionMap.get(sectionId).filter(({ id }) => {
          return id === bookmarkId;
        })[0]
      : contentSectionMap.get(sectionId);
    dispatch(
      onStatementNavSectionSelect({
        sectionId,
        color,
        bookmarkId,
        isOCR,
        sectionsInView,
      }),
    );
    dispatch(showStatementNavPanelAction());
    dispatch(showSectionDetailsPanelAction());
    isOCR
      ? await dispatch(fetchSectionReviewsOCRWithLoading())
      : await dispatch(fetchSectionReviewsWithLoading());

    if (!shouldDisableSectionClick) {
      dispatch(sectionDetailsLoading());
      let updatedSection = await getUpdatedSectionElementsNotesSummaryCount(
        revision,
        section,
        isOCR,
      );
      dispatch(sectionDetailsLoaded(updatedSection));
      dispatch(
        fetchSectionHistoryDetails({
          revisionId: revision.id,
          sectionId: isOCR ? bookmarkId : sectionId,
          isOCR,
        }),
      );
    }
    // this case is added because if the filter has just only one section selected and the user clicks on the section again
    // it is going to remove completely the section filter, so we need to remove the selected element
    if (
      !isOCR &&
      elementFilters &&
      elementFilters.isSectionSelected(sectionId) &&
      elementFilters.selectedSectionsLength() === 1
    ) {
      dispatch(deselectSelectedElement());
    }
    !isOCR &&
      dispatch(
        searchElements({
          filters: elementFilters.selectSection(section),
          searchTerm: '',
          scrollIntoView: false,
          sectionClick,
        }),
      );
  };

export const updateSectionDetailsStore =
  (props) => async (dispatch, getState) => {
    const { section, sectionId, isDelete } = props;
    const { selectedSection } = getState().data.sectionPanel;
    const {
      data: { revision },
    } = getState();
    // Added falsy value check - before evaluating selectedSection.id
    if (isDelete && selectedSection && sectionId === selectedSection.id) {
      dispatch(hideSectionDetailsPanelAction());
      dispatch(clearSectionDetails());
    }
    // Added check for falsy value - before evaluating section.id
    else if (section && selectedSection && selectedSection.id === section.id) {
      let updatedSection = await getUpdatedSectionElementsNotesSummaryCount(
        revision,
        section,
      );
      dispatch(sectionDetailsLoaded(updatedSection));
    }
  };

export const searchForTermInContent =
  ({ searchTerm, isOcr }) =>
  async (dispatch, getState) => {
    const {
      data: {
        statementContent: { sectionIdList },
      },
      ui: {
        statementPage: { sectionsInView },
      },
    } = getState();
    // ensure search term gets updated in redux
    await dispatch(setContentSearchAction(searchTerm));
    if (isOcr) {
      let sectionMetaData;
      sectionsInView.sectionIds.forEach((id) => {
        sectionMetaData = sectionIdList.sectionIds.find(
          (section) => section.sectionId === parseInt(id),
        );
        if (sectionMetaData) {
          dispatch(fetchAllOCRSectionRenderingData({ sectionMetaData }));
        }
      });
    } else {
      sectionsInView.sectionIds.forEach((id) => {
        // refetch all section data in order to iterate through and highlight content
        // search term should be updated already at this point
        dispatch(fetchAllSectionRenderingData({ sectionId: id }));
      });
    }
  };

export const clearSearchFromContent = () => async (dispatch, getState) => {
  const {
    data: {
      statementContent: { sectionIdList },
      selectedStatement: { isOCR },
    },
    ui: {
      statementPage: { sectionsInView },
    },
  } = getState();
  // clear selected element from searched element tab
  dispatch(deselectSelectedElement());
  // ensure search term gets updated in redux
  await dispatch(clearContentSearchAction());
  if (isOCR) {
    let sectionMetaData;
    sectionsInView.sectionIds.forEach((id) => {
      sectionMetaData = sectionIdList.sectionIds.find(
        (section) => section.sectionId === parseInt(id),
      );
      if (sectionMetaData) {
        dispatch(fetchAllOCRSectionRenderingData({ sectionMetaData }));
      }
    });
  } else {
    dispatch(clearContentHighlightSelector());
    sectionsInView.sectionIds.forEach((id) => {
      // refetch all section data in order to iterate through and highlight content
      // search term should be updated already at this point
      dispatch(fetchAllSectionRenderingData({ sectionId: id }));
    });
  }
};

export const refetchSectionsInView = () => async (dispatch, getState) => {
  const {
    ui: {
      statementPage: { sectionsInView },
    },
  } = getState();

  sectionsInView.sectionIds.forEach((id) => {
    // refetch all section data in order to iterate through and highlight content
    // search term should be updated already at this point
    dispatch(fetchAllSectionRenderingData({ sectionId: id }));
  });
};

export const deallocateItems = () => (dispatch, getState) => {
  const {
    data: {
      notesPanel: { selectedNote },
    },
    ui: {
      statementPage: {
        panels: { right },
      },
    },
  } = getState();
  dispatch(deallocateSelectedSectionsContentPanel());
  dispatch(deallocateSelectedElementsContentPanel());
  dispatch(clearContentHighlightSelector());

  if (right === RIGHT_PANELS.NOTES) {
    dispatch(
      selectNoteFromNoteListAction({
        note: selectedNote,
        color: 'default',
      }),
    );
  }
};

export const refetchBlacklineView = () => async (dispatch, getState) => {
  try {
    const { revision } = getState().data;
    const response = await getBlacklineViewStatusRequest({
      revisionId: revision.id,
    });

    if (response && response.data) {
      switch (response.data.result) {
        case BLACKLINE_VIEW_STATUS.BLK_REQ_RECEIVED:
          blacklineTogleNotification(BLACKLINE_VIEW_STATUS.BLK_REQ_RECEIVED);
          break;
        case BLACKLINE_VIEW_STATUS.GENERATING:
          blacklineTogleNotification(BLACKLINE_VIEW_STATUS.GENERATING);
          break;
        case BLACKLINE_VIEW_STATUS.FAILED:
          blacklineTogleNotification(BLACKLINE_VIEW_STATUS.FAILED);
          break;
        default:
          break;
      }
    }
  } catch (error) {
    blacklineTogleNotification(BLACKLINE_VIEW_STATUS.FAILED);
    console.error(error);
  }
};

// Target to Source
const WORKFLOW_TYPES = {
  DOC_TO_DOC: 1,
  PDF_TO_PDF: 2,
  DOC_TO_PDF: 3,
  PDF_TO_DOC: 4,
};

const getWorkflowTypeByStatementTypes = (sourceStatement, targetStatement) => {
  const isSourcePDF = !!sourceStatement;
  const isTargetPDF = !!targetStatement;

  if (isSourcePDF && isTargetPDF) return WORKFLOW_TYPES.PDF_TO_PDF;
  if (!isSourcePDF && !isTargetPDF) return WORKFLOW_TYPES.DOC_TO_DOC;
  if (!isSourcePDF && isTargetPDF) return WORKFLOW_TYPES.PDF_TO_DOC;
  if (isSourcePDF && !isTargetPDF) return WORKFLOW_TYPES.DOC_TO_PDF;
};

export const getMappedElementsOnAutoTieoutCompleted =
  ({
    clientId,
    sourceStatementId,
    targetStatementId,
    sourceRevisionId,
    targetRevisionId,
    initiatorId,
    currentUserId,
  }) =>
  async (dispatch) => {
    try {
      const response = await getAutoTieoutMapedElements({
        clientId,
        sourceStatementId,
        targetStatementId,
        sourceRevisionId,
        targetRevisionId,
      });
      dispatch(autoTieoutMapedElementsLoaded({ response }));
      const { sourceElements, targetElements } = (response?.data || []).reduce(
        (acc, item) => {
          acc.sourceElements.push(item.sourceElementId);
          acc.targetElements.push(item.targetElementId);
          return acc;
        },
        { sourceElements: [], targetElements: [] },
      );
      // highlighting mapped elements
      if (initiatorId === currentUserId) {
        dispatch(
          highlightMappedElementsByResponse({
            result: mapElementsSuccessResult,
            sourceElements,
            targetElements,
          }),
        );

        //on any key press or left click it will reset the successfully or failed mapped elements highlight to the default
        const clearHighlights = () => {
          document.removeEventListener('keydown', clearHighlights, true);
          document.removeEventListener('click', clearHighlights, true);
          dispatch(clearSelectedElementsContentPanel());
          dispatch(clearLeftSelectedElementsContentPanel());
        };
        document.addEventListener('keydown', clearHighlights, {
          capture: true,
          once: true,
        });
        document.addEventListener('click', clearHighlights, {
          capture: true,
          once: true,
        });
      }
    } catch (e) {
      console.error('fetching Mapped elements failed with error', e);
      dispatch(autoTieoutMapedElementsError({ error: e }));
    }
  };

// used to initiate auto tieout process in Side by Side view page
export const processAutoTieout =
  (statementId, revisionId, thresholdScalingValues = {}) =>
  async (dispatch, getState) => {
    const { ui, data } = getState();
    const {
      sourceStatementParams,
      sideBySideView: {
        sideBySideViewMode,
        autoTieout: { workpaperDetails, workFlowStatus },
        trialBalance: {
          tbWorkFlowStatus: { tbVersionId },
        },
      },
    } = ui;
    const {
      selectedProject: { id },
      selectedStatement: { isOCR },
    } = data;

    const workpaperId = workpaperDetails?.workpaperRefId;

    if (sideBySideViewMode?.viewMode === TRAIL_BALANCE_MODE) {
      await dispatch(
        initiateAutoTieoutForTrialBalance(
          statementId,
          revisionId,
          thresholdScalingValues,
          workpaperId,
          tbVersionId,
        ),
      );
    } else {
      const payload = {
        targetClientId: parseInt(id),
        targetRevisionId: parseInt(revisionId),
        sourceRevisionId: parseInt(sourceStatementParams.revisionId),
        targetStatementId: parseInt(statementId),
        sourceStatementId: parseInt(sourceStatementParams.statementId),
      };

      if (workFlowStatus.isCompleted) {
        payload.workflowId = workFlowStatus.workflowId;
      }

      const isSourceStatementOCR =
        sourceStatementParams.documentProcessType === 2 ? true : false;

      try {
        await autoTieoutProcessRequest({
          ...payload,
          workFlowStatus,
          // workpaper details in api format to be sent in the request body
          autoTieoutWorkPaper: {
            workflowType: getWorkflowTypeByStatementTypes(
              isSourceStatementOCR, // source statement type is OCR or not
              isOCR, // target statement type is OCR or not
            ),
            workpaperId: workpaperDetails?.workpaperRefId,
            sourceClientId: parseInt(sourceStatementParams.projectId),
            valueThreshold: thresholdScalingValues?.threshold,
            ...payload,
          },
        });
        await dispatch(getIsLinkedStatementCheck(true));
      } catch (error) {
        console.error('Auto tieout request failed with error: ', error);
        dispatch(
          setAutoTieoutStatusForBanner({
            status: AUTO_TIEOUT_COMPARE_MODE_FAILED,
          }),
        );
      } finally {
        dispatch(clearingElementMapSuccessAction());
        await dispatch(clearSideBySideElementsMap());
        await dispatch(resetMappedElements());
        await dispatch(cancelBatchUpdatePanel());
        await dispatch(clearModeIfPossible());
        await dispatch(clearSelectedElementsContentPanel());
        await dispatch(clearBatchSelectedElementsAction());
      }
    }
  };

export const retryAutoTieout = () => async (dispatch, getState) => {
  const { ui, data } = getState();
  const {
    sideBySideView: {
      autoTieout: { workFlowStatus },
    },
  } = ui;
  const { revision } = data;

  if (!workFlowStatus?.isLoaded || !workFlowStatus?.data) {
    return;
  }

  dispatch(
    setAutoTieoutStatusForBanner({
      status: AUTO_TIEOUT_COMPARE_MODE_INPROGRESS,
    }),
  );

  try {
    await autoTieoutRetryRequest(workFlowStatus.data);
  } catch (error) {
    dispatch(
      setAutoTieoutStatusForBanner({ status: AUTO_TIEOUT_COMPARE_MODE_FAILED }),
    );
  }

  // Socket will handle status updates and show notifications
  // Don't call getIsLinkedStatementCheck - let socket handle it
};

// this function will check the auto tieout workflow status for linked statements and accordingly show success or failure notification
// and also update the workpaper reference in the store after getting response from the workpaper get api
export const getIsLinkedStatementCheck =
  (isAutoTieoutProcess = false) =>
  async (dispatch, getState) => {
    const { ui, data, sockets } = getState();
    const { socketHasBeenDisconnected } = sockets.statementSocket;
    const {
      sourceStatementParams,
      statementPage: { sectionsInView },
      sideBySideView: {
        trialBalance: { thresholdScaling },
      },
    } = ui;
    const {
      revision,
      selectedProject: { id },
      selectedStatement: { statementId, isOCR },
      annotationDisplayOptions,
    } = data;

    const payload = {
      targetClientId: parseInt(id),
      targetRevisionId: parseInt(revision.id),
      sourceRevisionId: parseInt(sourceStatementParams.revisionId),
      targetStatementId: parseInt(statementId),
      sourceStatementId: parseInt(sourceStatementParams.statementId),
    };

    let autoTieoutWorkflow;
    // to fetch auto tieout workflow details to show progress of auto tieout process with latest status
    try {
      dispatch(autoTieoutWorkflowDataLoading());
      autoTieoutWorkflow = await autoTieoutWorkFlowRequest({
        ...payload,
      });
      const workflowStatus = autoTieoutWorkflow?.data?.status;
      dispatch(autoTieoutWorkflowDataLoaded(autoTieoutWorkflow));
      dispatch(
        setAutoTieoutStatusForBanner({
          status: isNullOrUndefined(workflowStatus) ? null : workflowStatus,
        }),
      );
      dispatch(
        setThreshold(
          autoTieoutWorkflow?.data?.valueThreshold ||
            thresholdScaling?.threshold,
        ),
      );

      const isAutoTieoutProcessWhenSocketDisconnected =
        socketHasBeenDisconnected && isAutoTieoutProcess;
      if (
        isAutoTieoutProcessWhenSocketDisconnected &&
        workflowStatus === AUTO_TIEOUT_COMPARE_MODE_SUCCESS
      ) {
        successElementMapNotification({
          processType: AUTO_TIEOUT_COMPARE_MODE,
        });
        const loadedSectionsInView = Object.keys(sectionsInView);
        dispatch(reFetchElementsForSectionsInView(loadedSectionsInView, isOCR));
        // dispatch expand All annotations on success
        dispatch(
          setAnnotationDisplayOption({
            ...annotationDisplayOptions,
            showAll: true,
          }),
        );
      } else if (
        isAutoTieoutProcessWhenSocketDisconnected &&
        workflowStatus === AUTO_TIEOUT_COMPARE_MODE_FAILED
      ) {
        failureElementMapNotification({
          processType: AUTO_TIEOUT_COMPARE_MODE,
        });
      } else if (
        // fetching mapped elements after auto tieout process is completed successfully
        !isAutoTieoutProcess &&
        workflowStatus === AUTO_TIEOUT_COMPARE_MODE_SUCCESS
      ) {
        dispatch(
          fetchAutoTieoutMapedElements({
            clientId: parseInt(id),
            sourceStatementId: parseInt(sourceStatementParams.statementId),
            targetStatementId: parseInt(statementId),
            sourceRevisionId: parseInt(sourceStatementParams.revisionId),
            targetRevisionId: parseInt(revision.id),
          }),
        );
      }
    } catch (error) {
      console.error('Auto tieout workflow status request error', error);
      dispatch(autoTieoutWorkflowDataError(error));
      dispatch(setAutoTieoutStatusForBanner({ status: null }));
    }

    // to fetch workpaper details for auto tieout process workpaper
    try {
      const wpResponse = await getWorkpaperByAutoTieoutStatement({
        revisionId: revision.id,
        statementId,
        workPaperId: autoTieoutWorkflow?.data?.workpaperId,
      });
      // to update the auto tieout workpaper reference in the store after getting response from the workpaper get api
      wpResponse?.data?.result &&
        dispatch(setAutoTieoutWorkpaperReference(wpResponse));
    } catch (err) {
      console.error('Auto tieout process workpaper error', err);
    }
  };

export const mapSideBySideElementsRequest =
  (statementId, revisionId) => async (dispatch, getState) => {
    const { ui, data } = getState();
    const {
      sourceStatementParams,
      sideBySideView,
      statementPage: { sectionsInView },
    } = ui;
    const {
      currentUser,
      statementContent,
      selectedStatement: { isOCR },
    } = data;
    const sectionIdList = statementContent && statementContent.sectionIdList;
    const targetId = revisionId;
    const targetStatementId = statementId;
    const sourceId = sourceStatementParams && sourceStatementParams.revisionId;
    const sourceStatementId =
      sourceStatementParams && sourceStatementParams.statementId;
    let elementMapDetails = { ...sideBySideView.sideBySideViewAnnotations };
    elementMapDetails.userId = currentUser && currentUser.id;
    elementMapDetails.elementsforMapping =
      sideBySideView &&
      sideBySideView.sideBySideElementMap &&
      sideBySideView.sideBySideElementMap.toApiFormat();

    const sourceElements =
      sideBySideView &&
      sideBySideView.sideBySideElementMap &&
      sideBySideView.sideBySideElementMap.sideBySideSourceElementsId();
    const targetElements =
      sideBySideView &&
      sideBySideView.sideBySideElementMap &&
      sideBySideView.sideBySideElementMap.sideBySideTargetElementsId();

    try {
      // api request to mapping element based on the user selection in side by side view page.
      const response = await mapElementsRequest({
        targetId,
        sourceId,
        targetStatementId,
        sourceStatementId,
        elementMapDetails,
      });

      if (
        response &&
        response.data &&
        response.data.elementsforMapping.length !== 0
      ) {
        const {
          successSourceElements,
          failedSourceElements,
          successTargetElements,
          failedTargetElements,
        } = seggregateSourceTargetElements(response.data.elementsforMapping);
        if (isOCR) {
          const sectionInViewIds = Object.keys(sectionsInView);
          const sectionIdListMap = sectionIdList.sectionIds.reduce(
            (map, sectionMetaData) => {
              map[sectionMetaData.sectionId] = sectionMetaData;
              return map;
            },
            {},
          );
          sectionInViewIds.forEach(async (sectionInViewId) => {
            const sectionMetaData = sectionIdListMap[sectionInViewId];
            if (sectionMetaData) {
              await dispatch(
                fetchSectionOCRSegmentsStatementContent({ sectionMetaData }),
              );
            }
          });
        } else {
          const sectionInViewIds = Object.keys(sectionsInView)
            .map((key) => Number(key))
            .filter((key) => !isNaN(key));
          dispatch(
            fetchSectionHTMLSegmentsStatementContentWithoutLoading({
              sectionIdList: sectionInViewIds,
              segmentType: 'P',
            }),
          );
        }
        await dispatch(updateCacheWithMostRecentSideBySideElementChanges());
        dispatch(
          highlightMappedElementsByResponse({
            result: mapElementsSuccessResult,
            sourceElements: successSourceElements,
            targetElements: successTargetElements,
          }),
        );
        dispatch(
          highlightMappedElementsByResponse({
            result: mapElementsFailureResult,
            sourceElements: failedSourceElements,
            targetElements: failedTargetElements,
          }),
        );
        dispatch(clearSideBySideElementsMap());

        // successfully mapped elements notification
        !!successTargetElements.length &&
          successElementMapNotification({
            processType: SIDE_BY_SIDE_COMPARE_MODE,
            targetElements: successTargetElements,
          });
        // failed mapped elements notification
        !!failedTargetElements.length &&
          failureElementMapNotification({
            processType: SIDE_BY_SIDE_COMPARE_MODE,
            targetElements: failedTargetElements,
          });
        !!successTargetElements.length &&
          dispatch(
            updateElementCacheByCalloutAction({
              elementIds: successTargetElements,
              showCallout: true,
            }),
          );
      } else {
        dispatch(
          handleElementMappingFailure(
            mapElementsFailureResult,
            sourceElements,
            targetElements,
          ),
        );
      }
    } catch (error) {
      dispatch(
        handleElementMappingFailure(
          mapElementsFailureResult,
          sourceElements,
          targetElements,
        ),
      );
    }
    //on any key press or left click it will reset the successfully or failed mapped elements highlight to the default
    const clearHighlights = () => {
      document.removeEventListener('keydown', clearHighlights, true);
      document.removeEventListener('click', clearHighlights, true);
      dispatch(clearSelectedElementsContentPanel());
      dispatch(clearLeftSelectedElementsContentPanel());
    };
    document.addEventListener('keydown', clearHighlights, {
      capture: true,
      once: true,
    });
    document.addEventListener('click', clearHighlights, {
      capture: true,
      once: true,
    });
  };

export const performManualMappingInAutoTieout =
  ({ sideBySideElementMap, sourceStatementParams, targetStatementParams }) =>
  async (dispatch, getState) => {
    const sizeOfSourceMapping = sideBySideElementMap.sizeOfSourceMapping;
    const sizeOfTargetMapping = sideBySideElementMap.sizeOfTargetMapping;
    const [sourceElementDetails] =
      sideBySideElementMap.sourceStatementElementMap.values();
    const [targetElementDetails] =
      sideBySideElementMap.targetStatementElementMap.values();
    const workpaper =
      getState()?.ui?.sideBySideView?.autoTieout?.workpaperDetails;

    if (sizeOfSourceMapping && sizeOfTargetMapping) {
      if (!workpaper.isLoaded) {
        console.error(
          'Manual mapping in auto tieout failed due to workpaper details not loaded',
        );
        return;
      }
      try {
        const elementMapping = {
          sourceElementId: parseInt(sourceElementDetails.id),
          targetElementId: parseInt(targetElementDetails.id),
        };

        const wp = workpaper.data;
        const autoTieoutElementMappingPayload = {
          workpaperReferenceDto: {
            revisionId: wp.revisionId,
            elementId: parseInt(targetElementDetails.id),
            workpaperRefId: wp.workpaperRefId,
            referenceNumber: wp.referenceNumber,
            referenceName: wp.referenceName,
            workpaperRefCreatedBy: wp.workpaperRefCreatedBy,
            workpaperRefCreatedDate: wp.workpaperRefCreatedDate,
            elementWpRefCreatedBy: wp.elementWpRefCreatedBy,
            elementWpRefCreatedDate: wp.elementWpRefCreatedDate,
            elementCount: wp.elementCount,
            creationType: 'MANUAL',
            overrideCreationType: wp.overrideCreationType,
          },
          sourceClientId: parseInt(sourceStatementParams.projectId),
          sourceStatementId: parseInt(sourceStatementParams.statementId),
          sourceRevisionId: parseInt(sourceStatementParams.revisionId),
          targetClientId: parseInt(targetStatementParams.projectId),
          targetStatementId: parseInt(targetStatementParams.statementId),
          targetRevisionId: parseInt(targetStatementParams.revisionId),
          elementMapping,
          sourceDisplayValue: sourceElementDetails.display,
          targetDisplayValue: targetElementDetails.display,
        };
        const response = await mapElementsWithWorkpaperInAutotieout({
          clientId: parseInt(targetStatementParams.projectId),
          mappingPayload: autoTieoutElementMappingPayload,
        });
        //since we are on auto tieout mode,we are not using response (workpaper entity) data to update the store.
        //We are only updating the element cache so that mapped WP will get reflected on statement content panel.
        //No other data needs to be updated becasue user can not open any panel(left/right) in auto tieout mode.
        if (response.status === StatusCodes.OK) {
          const response = await getElementDetailsRequest({
            revisionId: targetStatementParams.revisionId,
            elementId: targetElementDetails.id,
          });
          const elementToUpdate = new ElementDetails();
          const elementWithCalloutDetails =
            elementToUpdate.setLoadedFromElementData({
              data: { ...response.data.result, callout: true, marker: false },
            });
          dispatch(
            updateElementInCacheAction({ element: elementWithCalloutDetails }),
          );
          dispatch(
            highlightMappedElementsByResponse({
              result: mapElementsSuccessResult,
              sourceElements: [sourceElementDetails.id],
              targetElements: [targetElementDetails.id],
            }),
          );
          dispatch(
            fetchAutoTieoutMapedElements({
              clientId: parseInt(targetStatementParams.projectId),
              sourceStatementId: parseInt(sourceStatementParams.statementId),
              targetStatementId: parseInt(targetStatementParams.statementId),
              sourceRevisionId: parseInt(sourceStatementParams.revisionId),
              targetRevisionId: parseInt(targetStatementParams.revisionId),
              withoutLoading: true,
            }),
          );
        }
      } catch (error) {
        dispatch(
          highlightMappedElementsByResponse({
            result: mapElementsFailureResult,
            sourceElements: [sourceElementDetails.id],
            targetElements: [targetElementDetails.id],
          }),
        );
      } finally {
        dispatch(clearSideBySideElementsMap());
      }

      //on any key press or left click it will reset the successfully or failed mapped elements highlight to the default
      const clearHighlights = () => {
        document.removeEventListener('keydown', clearHighlights, true);
        document.removeEventListener('click', clearHighlights, true);
        dispatch(clearSelectedElementsContentPanel());
        dispatch(clearLeftSelectedElementsContentPanel());
      };
      document.addEventListener('keydown', clearHighlights, {
        capture: true,
        once: true,
      });
      document.addEventListener('click', clearHighlights, {
        capture: true,
        once: true,
      });
    }
  };

export const clearAllLeftStatementData = () => (dispatch) => {
  dispatch(cancelBatchUpdatePanel());
  dispatch(clearModeIfPossible());
  dispatch(clearleftSectionTreeListAction());
  dispatch(clearLeftStatementContent());
  dispatch(clearLeftSelectedStatement());
  dispatch(clearLeftStatementPageStoreAction());
  dispatch(removeAutoTieoutWorkpaperReference());
  dispatch(resetAutoTieoutWorkflowData());
  dispatch(clearAutoTieoutMapedElements());
  dispatch(clearSelectedElementsContentPanel());
  dispatch(clearBatchSelectedElementsAction());
  dispatch(resetThresholdScaling());
  dispatch(clearTrialBalanceMapedElements());
  dispatch(removeTBSourceElementClicked());
  dispatch(removeTBTargetElementClicked());
  dispatch(resetTrailBalanceWorkFlowStatus());
};

// function to dispatch fetch operations for elements based on sections in view
// used when re-fetching elements without loading state
export const reFetchElementsForSectionsInView =
  (loadedSectionsInView, isOCRStatement, isAutoTieoutProcess) => (dispatch) => {
    const promises = loadedSectionsInView.map((sectionId) => {
      return isOCRStatement
        ? dispatch(
            fetchElementsBySectionOCR({
              sectionId,
              withoutLoading: true,
              isAutoTieoutProcess,
            }),
          )
        : dispatch(
            fetchElementsBySection({
              sectionId,
              withoutLoading: true,
              isAutoTieoutProcess,
            }),
          );
    });
    return Promise.all(promises);
  };

export const handleElementQuickAction =
  ({ element, action }) =>
  async (dispatch, getState) => {
    const { data, ui } = getState();
    const { elementDetails } = data.elementPanel;
    const {
      selectedProject: { id },
      revision,
    } = data;
    const { workpaperDetails } = ui?.sideBySideView?.autoTieout ?? {};

    const updateElementWithAPI = async (updatedElement, errorMessage) => {
      dispatch(updateElementInCacheAction({ element: updatedElement }));
      try {
        await updateElementRequest({
          revisionId: revision.id,
          elementId: element.id,
          elementDetails: updatedElement,
        });
      } catch (error) {
        console.error(errorMessage, error);
        dispatch(updateElementInCacheAction({ element }));
      }
    };

    const updateElementInStore = (updatedElement) => {
      dispatch(updateElementInCacheAction({ element: updatedElement }));
      dispatch(
        _updateElementInStoreAndElementCacheByQuickAction({
          elementDetails: updatedElement,
        }),
      );
    };

    const actionHandlers = {
      [ELEMENT_QUICK_ACTIONS.USER_FLAG]: () =>
        updateElementWithAPI(
          element.setUserFlag({ userFlag: true }),
          'Failed to update user flag:',
        ),

      [ELEMENT_QUICK_ACTIONS.REMOVE_USER_FLAG]: () =>
        updateElementWithAPI(
          element.setUserFlag({ userFlag: false }),
          'Failed to remove user flag:',
        ),

      [ELEMENT_QUICK_ACTIONS.OVERRIDE_FLAG]: () =>
        updateElementWithAPI(
          element.setOverrideSystemFlag({ systemFlag: false }),
          'Failed to remove system flag override:',
        ),

      [ELEMENT_QUICK_ACTIONS.EXCLUDE_ELEMENT]: () =>
        dispatch(
          excludeElement({
            elementId: element.id,
            revisionId: element.revisionId,
          }),
        ),

      [ELEMENT_QUICK_ACTIONS.ADDFORMULA]: async () => {
        await dispatch(
          onElementClick({
            elementId: element.id,
            sectionId: element.sectionId,
            isDisabled: false,
          }),
        );
        dispatch(showFormulaPanelAction(true));
        elementDetails.isLoaded &&
          (dispatch(setNewFormulaAction(true)),
          dispatch(initFormulaCreate(element)));
      },

      [ELEMENT_QUICK_ACTIONS.UNLINK_AUTO_TIEOUT_REFERENCES]: () =>
        dispatch(
          unlinkElementWorkpaperFromAutoTieout({
            workpaper: workpaperDetails.autoTieoutWPDetails,
            elementDetails: element,
          }),
        ),

      [ELEMENT_QUICK_ACTIONS.REMOVE_FORMULA]: async () => {
        // const deleteFormulaResponse = await deleteFormulaRequestByQuickAction({
        //   clientId: id,
        //   revisionId: element.revisionId,
        //   elementId: element.id,
        // });
        console.log('delete Formula Response');
      },

      [ELEMENT_QUICK_ACTIONS.VERIFY]: () =>
        updateElementInStore(element.setVerify({ verified: true })),

      [ELEMENT_QUICK_ACTIONS.UNVERIFY]: () =>
        updateElementInStore(element.setVerify({ verified: false })),

      [ELEMENT_QUICK_ACTIONS.REVIEW]: () =>
        updateElementInStore(element.setReview({ reviewed: true })),

      [ELEMENT_QUICK_ACTIONS.UNREVIEW]: () =>
        updateElementInStore(element.setReview({ reviewed: false })),

      [ELEMENT_QUICK_ACTIONS.ASSIGN_COMFORT]: () =>
        updateElementInStore(
          element.setComfortAssign({
            comfortAssignVal: !element.comfortAssign,
          }),
        ),

      [ELEMENT_QUICK_ACTIONS.ASSIGN_COMFORT_LETTER]: () => {},

      [ELEMENT_QUICK_ACTIONS.CHANGE_SIGN]: () =>
        updateElementInStore(
          element.setSignFlag({ signFlag: !element.signFlag }),
        ),
    };

    const handler = actionHandlers[action.type];
    if (handler) {
      await handler();
    }
  };

export const handleSystemFlagOverride =
  ({ element, systemFlag }) =>
  async (dispatch, getState) => {
    if (!element) {
      throw new Error(
        'Cannot update override system flag: no element provided',
      );
    }

    const { revision } = getState().data;
    const updatedElement = element.setOverrideSystemFlag({ systemFlag });
    dispatch(updateElementInCacheAction({ element: updatedElement }));

    try {
      const { updateElementRequest } = await import('../../api/element-api');
      await updateElementRequest({
        revisionId: revision.id,
        elementId: element.id,
        elementDetails: updatedElement,
      });
    } catch (error) {
      dispatch(updateElementInCacheAction({ element }));
      throw new Error(
        `Failed to update system flag override: ${error.message}`,
      );
    }
  };

export const convertDTOToRows = (formulaElementDtoList) => {
  let includedElementIds = [];
  const rows = formulaElementDtoList.map((formulaElementDto) => {
    switch (formulaElementDto.type) {
      case FORMULA_ROW_TYPES.ELEMENT: {
        includedElementIds.push(formulaElementDto.includedElementId);
        return new FormulaRowElement({
          elementData: {
            id: formulaElementDto.includedElementId,
            amount: formulaElementDto.includedElementAmount,
            elementActive: formulaElementDto.elementActive,
            scalingId: formulaElementDto.includedElementScalingId || 0,
          },
        });
      }
      case FORMULA_ROW_TYPES.NUMBER: {
        return new FormulaRowNumber({
          value: formulaElementDto.value,
        });
      }
      case FORMULA_ROW_TYPES.OPERATOR: {
        return new FormulaRowOperator({
          value: formulaElementDto.value,
        });
      }
      default: {
        console.error('INVALID FORMULA ROW TYPE');
        return null;
      }
    }
  });
  return {
    rows,
    includedElementIds,
  };
};

/**
 * Highlights formula-related elements when hovering over an element that has formulas.
 * Retrieves all elements included in the formula and highlights them on the statement content.
 *
 * @param {Object} elementData - The element being hovered over
 * @param {Object} elementRef - React ref to the element DOM node for hover state validation
 *
 * Note: Does not highlight in side-by-side view mode or for elements without formulas.
 */
export const handleElementFormulaHighlight =
  (elementData, elementRef) => async (dispatch, getState) => {
    const {
      data: {
        statementContent: { elementCache },
        elementPanel: { elementDetails, formulaList },
        revision: { id },
      },
    } = getState();

    const elementFromStore = elementCache?.getElement({
      sectionId: elementData?.sectionId,
      elementId: elementData?.id,
    });

    if (
      window.location.pathname.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE) ||
      !elementFromStore?.id ||
      !elementFromStore?.hasFormula()
    ) {
      return;
    }

    let elementIdsInFormulas = [];

    if (formulaList?.isLoaded && elementDetails?.id === elementFromStore?.id) {
      elementIdsInFormulas = formulaList?.getElementIdsInFormulas();
    } else {
      try {
        const response = await getFormulasForElementRequest({
          elementId: elementFromStore?.id,
          revisionId: id,
        });

        if (!elementRef?.current?.matches(':hover')) return;

        elementIdsInFormulas = [
          ...new Set(
            (response?.data?.result ?? []).flatMap(
              (formula) =>
                convertDTOToRows(formula.formulaElementDtoList)
                  .includedElementIds,
            ),
          ),
        ];
      } catch (error) {
        console.error('Failed to fetch formulas for element:', error);
        return;
      }
    }

    if (elementIdsInFormulas.length && elementRef?.current?.matches(':hover')) {
      dispatch(
        replaceSelectedElementWithoutRemovingOld({
          elementIds: elementIdsInFormulas,
          color: ELEMENT_HIGHLIGHT_STATES.HOVERED_FROM_STATEMENT_CONTENT,
        }),
      );
    }
  };

/**
 * Removes formula-related element highlights when mouse leaves an element.
 * Cleans up the highlighting that was applied by handleElementFormulaHighlight.
 * In batch mode, also restores the default batch element selection state.
 *
 * @param {Object} elementData - The element that is no longer being hovered
 *
 * Note: Does not execute in side-by-side view mode.
 */
export const removeElementFormulaHighlight =
  (elementData) => async (dispatch, getState) => {
    const {
      data: {
        batchPanel: { batchElementList },
      },
      ui: {
        statementPage: {
          selectedElementsMap,
          modes: { selectMode },
        },
      },
    } = getState();

    const isBatchMode =
      selectMode === ELEMENT_SELECT_MODES.BATCH ||
      selectMode === ELEMENT_SELECT_MODES.BATCH_WITH_BANNER ||
      batchElementList?.elementsSelected?.length > 0;

    if (
      !window.location.pathname.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE) &&
      elementData?.id &&
      Object.keys(selectedElementsMap).length > 0
    ) {
      const elementIdsToDeselect = Object.entries(selectedElementsMap)
        .filter(
          ([, value]) =>
            value.color ===
            ELEMENT_HIGHLIGHT_STATES.HOVERED_FROM_STATEMENT_CONTENT,
        )
        .map(([key]) => parseInt(key, 10))
        .filter((elementId) => elementId !== elementData.id);

      if (elementIdsToDeselect.length) {
        await dispatch(
          deselectElementsFromArrayContentPanel(elementIdsToDeselect),
        );
      }
      // If in batch mode, restore the default selection state for batch elements
      if (isBatchMode) {
        dispatch(
          replaceSelectedElementsContentPanel({
            elementIds: batchElementList.elementsSelected,
            color: ELEMENT_HIGHLIGHT_STATES.DEFAULT,
          }),
        );
      }
    }
  };

export const fetchAutoTieoutMappedElementByMode =
  ({
    clientId,
    sourceStatementId,
    targetStatementId,
    sourceRevisionId,
    targetRevisionId,
    withoutLoading,
  }) =>
  async (dispatch, getState) => {
    const {
      ui: {
        sideBySideView: { sideBySideViewMode },
      },
    } = getState();
    const isAutoTieoutMode =
      sideBySideViewMode?.viewMode === AUTO_TIEOUT_COMPARE_MODE;
    const isTrialBalanceMode =
      sideBySideViewMode?.viewMode === TRAIL_BALANCE_MODE;

    if (isAutoTieoutMode) {
      await dispatch(
        fetchAutoTieoutMapedElements({
          clientId,
          sourceStatementId,
          targetStatementId,
          sourceRevisionId,
          targetRevisionId,
          withoutLoading,
        }),
      );
      dispatch(removeSourceElementClicked());
      dispatch(removeTargetElementClicked());
    } else if (isTrialBalanceMode) {
      await dispatch(
        fetchTrialBalanceMapedElements({
          clientId,
          statementId: targetStatementId,
          revisionId: targetRevisionId,
          withoutLoading,
        }),
      );
      dispatch(removeTBSourceElementClicked());
      dispatch(removeTBTargetElementClicked());
    }
  };
